import React from 'react'
import { steps } from '../../../data/home.dummy'
import { Step } from 'cwp-components/utils/Step'

const HowItWorks = () => {
  return (
    <section id='how-it-works' className='flex justify-center mt-12 mx-48'>
      <div>
        <div className='rounded-[16px] p-5 border border-[#D9E0DF] bg-[#EBF3FF] shadow-[0px_2px_20px_rgba(187,199,215,0.2)] sm:text-sm'>
          <h5 className='mb-3'>How it works</h5>
          <div className='self-stretch h-px opacity-25 bg-[radial-gradient(ellipse_50.00%_50.00%_at_50.00%_50.00%,_#0C3A78_0%,_rgba(24.63,_64.96,_118.73,_0)_100%)]' />
          <div
            id='step'
            className='flex justify-between text-center w-full gap-6'
          >
            {steps.map((step, idx) => (
              <div className='flex-1'>
                <Step data={step} length={steps.length} key={idx} count={idx} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
